/**
 * @author: dongjing
 * @file: 文章分页数据列表（圈子，团队，标签页面）
 * @Date: 2020-01-06 19:05:13
 * @LastEditors: dongjing
 * @LastEditTime: 2020-01-16 12:05:32
 */
import React from 'react';
import * as models from '@src/services/model/models';
import { Article, SFCPagination } from '..';
import './TabArticleList.less';
export interface ITabArticleListProps {
  /** 文章数据列表 */
  articleModel: models.PageableResultSingleArticleInfo;
  /** 加载状态 */
  loading: boolean;
  /** 更改页码 */
  changePage: (pageNum: number) => void;
  /** 提示 */
  customOption?: React.ReactNode;
  /** 取消收藏 */
  collectCancle?: (item: models.SingleArticleInfo) => void;
  /** 删除文章 */
  handleDelete?: (businessId: string, articleStatus: string) => void;
  /** 能否操作 */
  canEdit?: boolean;
  /** 是否是搜索页面使用 */
  search?: boolean;
  /** 是否是管理员 */
  isAdmin?: boolean;
  /** 是否需要置顶操作 */
  pinned?: boolean;
  /** 文章置顶 */
  stickyArticle?: (stickType: number, articleOrQuestionId: number, type: number) => void;
}
type Props = ITabArticleListProps;

export function TabArticleList(props: Readonly<Props>) {
  const {
    articleModel,
    loading,
    changePage,
    customOption,
    collectCancle,
    handleDelete,
    canEdit = false,
    search = false,
    isAdmin = false,
    pinned = false,
    stickyArticle
  } = props;

  /** 分页点击 */
  const changePageNum = (pageNum: number) => {
    changePage(pageNum);
  };
  const articleSticky = (stickType: number, articleOrQuestionId: number) => {
    stickyArticle && stickyArticle(stickType, articleOrQuestionId, 1);
  };
  return (
    <div className="common-presenter k-common-tab-article-list">
      <Article
        className="common-presenter k-circle-article-list"
        data={(articleModel.list as models.SingleArticleInfo[]) || []}
        from={search ? 'search' : 'personal'}
        loading={loading}
        customOption={customOption}
        customClick={collectCancle}
        handleDelete={handleDelete}
        showOption={canEdit}
        isAdmin={isAdmin}
        pinned={pinned}
        articleSticky={articleSticky}
      />
      {articleModel.list && articleModel.list.length > 0 && (
        <SFCPagination
          pageNum={articleModel.pageNum || 1}
          pageSize={articleModel.pageSize || 10}
          total={articleModel.total || 0}
          onChange={changePageNum}
        />
      )}
    </div>
  );
}

export default TabArticleList;
